module.exports = __webpack_public_path__ + "static/media/header-hero-right.501c7c6e.png";